'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import PrismItem from './prism-item';
import PrismItemDeleted from './prism-item-deleted';
import SpinnerCover from '../_utils/spinner-cover';

// -----------------------------------------------------------
//  Prism
// -----------------------------------------------------------
const Prism = ({ items, updating, outOfStock, alternatePickupStore }) => {
  const $items = items.map((item, i) => {
    const $item = item.deleted
      ? <PrismItemDeleted {...item} />
      : <PrismItem {...item}
                   outOfStock={outOfStock && outOfStock.includes(item.id)}
                   alternatePickupStore={alternatePickupStore} />;

    return (
      <SpinnerCover
        key={i}
        spinning={updating['all'] || updating[item.id]}>
        <section className="prism">
          {$item}
        </section>
      </SpinnerCover>
    );
  });

  return (
    <div>
      {$items}
    </div>
  );
};

export default Prism;
